export default __webpack_public_path__ + "static/media/condiments-vegshelf.e80ff4f3.png";